import { FC } from 'react';

import styles from './styles.module.scss';

export const Title: FC<{
    text: string;
}> = ({ text }) => {
    return <h1 className={styles.title}>{text}</h1>;
};
